
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BgBtnCountdown from "@/components/bg-btn-countdown/index.vue";
import { StepForm } from "../../common/StepForm";
import { genCacheMixin } from "../../common/cache.mixin";
import { settledAuditStatusEnum } from "@/service/supplier-meta/enums/settledAuditStatusEnum";
import {
  sendVerificationCodeByPhone,
  getSupplierByPhone,
} from "@/service/supplier-meta/api";
@Component({
  components: {
    BgBtnCountdown,
  },
  mixins: [
    genCacheMixin({
      field: "form",
      saveKey: "BindCellphone",
    }),
  ],
})
export default class BindCellphone extends StepForm {
  form = {
    bindingPhone: "",
  };
  verifyCode = "";
  supplierInfo = {};
  messageDialogState = {
    visible: false,
    state: "",
  };
  async validate() {
    const phoneValid = this.validatePhoneNo();
    if (!phoneValid) {
      return false;
    } else if (!this.verifyCode) {
      this.$message.warning("请输入短信验证码！");
      return false;
    } else {
      const res = await getSupplierByPhone({
        phone: this.form.bindingPhone,
        source: 14,
        verify_code: this.verifyCode,
      });
      if (!res.isSuccess) {
        return false;
      }
      if (res.result?.supplier) {
        const supplierInfo = res.result.supplier || {};
        this.supplierInfo = supplierInfo;
        const canReAplly =
          res.result.resSupplierSettledAuditInfoDTO.settledAuditStatus ===
          settledAuditStatusEnum.审核不通过;
        const settledAuditStatus =
          res.result?.resSupplierSettledAuditInfoDTO?.settledAuditStatus;
        if (canReAplly) {
          //审核不通过可重新发起
          // this.$emit("fetchData", supplierInfo);
          this.$confirm(
            `您申请的“${supplierInfo.name}”审核不通过，是否重新发起入驻？`,
            "重新入驻确认",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            this.$emit("reSubmit", supplierInfo);
          });
        } else if (
          settledAuditStatus === settledAuditStatusEnum.未审核 ||
          settledAuditStatus === settledAuditStatusEnum.审核中
        ) {
          //审核中
          this.messageDialogState.state = "audit";
          this.messageDialogState.visible = true;
        } else if (settledAuditStatus === settledAuditStatusEnum.已审核) {
          // 审核通过
          this.messageDialogState.state = "passed";
          this.messageDialogState.visible = true;
        } else if (settledAuditStatus === settledAuditStatusEnum.待认证) {
          // 待邮箱认证
          // 审核通过
          this.messageDialogState.state = "pendding";
          this.messageDialogState.visible = true;
        }
        return false;
      }
    }
    return true;
  }
  getFormData() {
    return this.form;
  }
  validatePhoneNo() {
    const phoneReg = /^\d{11}$/;
    const valid = phoneReg.test(this.form.bindingPhone);
    if (!valid) {
      this.$message.warning("请输入手机号码！");
    }
    return valid;
  }
  async handleCountdown() {
    const res = await sendVerificationCodeByPhone({
      phone: this.form.bindingPhone,
      source: 14,
    });
    if (res.result) {
      this.$message.success("验证码已发送到您的手机，请注意查收！");
    }
    console.log(res);
  }
  async handleNextBtnClick() {
    this.$emit("next", this.form);
  }
  cancel() {
    console.log("cancel");
    this.$emit("cancel");
  }
}
